import BannerSmallVideo from '../../../assets/about/about-banner-mobile.mp4';
import AboutMainJpgSmall from '../../../assets/about/about-banner-small.jpg';
import AboutMainJpg from '../../../assets/about/about-banner.jpg';
import BannerVideo from '../../../assets/about/about-banner.mp4';
import AboutMainWebp from '../../../assets/about/about-banner.webp';
import LogoMain from '../../../assets/about/about-logo-main.png';
import VideoBanner from '../../../components/videoBanner/VideoBanner';
import { ScreenSize, useScreenSize } from '../../../hooks/useScreenSize';
import { getWebpSupport } from '../../../utils/get-webp-support.utils';

import styles from './AboutBanner.module.scss';

const AboutMain = getWebpSupport() ? AboutMainWebp : AboutMainJpg;

const AboutBanner = ({ onInitialized }: { onInitialized: () => void }) => {
  const screenSize = useScreenSize();

  return (
    <div className={styles['banner']}>
      {screenSize > ScreenSize.extraSmall ? (
        <VideoBanner
          className={styles['banner-video']}
          mp4VideoUrl={BannerVideo}
          videoAnimationThreshold={0.4}
          onInitialized={onInitialized}
        ></VideoBanner>
      ) : (
        <VideoBanner
          className={styles['banner-video']}
          mp4VideoUrl={BannerSmallVideo}
          videoAnimationThreshold={0.4}
          onInitialized={onInitialized}
        ></VideoBanner>
      )}
      <img
        alt="landlord go offer"
        className={styles['banner-image']}
        src={screenSize > ScreenSize.extraSmall ? AboutMain : AboutMainJpgSmall}
        width="1920"
        height="1080"
      />
      <img alt="Reality NFT" className={styles['logo-main']} src={LogoMain} />
    </div>
  );
};

export default AboutBanner;
